export default __webpack_public_path__ + "static/media/Background_00271.dc14d7be.png";